module.exports = __webpack_public_path__ + "static/media/nav-icon-role-definition-active.9baa0c93.svg";